<script>
	import TopAppBar, { Row, Section, Title } from '@smui/top-app-bar';
</script>

<div class="top-app-bar-container">
	<TopAppBar variant="static" color="secondary">
		<Row>
			<Section>
				<a href="https://sbudnic.space/" class="linkToPage">
					<Title>About SBUDNIC</Title>
				</a>
			</Section>
		</Row>
	</TopAppBar>
</div>

<style>
	.top-app-bar-container {
		background-color: #fff;
	}

	.linkToPage {
		color: inherit;
	}
</style>